import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'
import { isFullArray } from '@helpers/array'

const getCoveredLessons = (state: ProgressReportStore): string[] => getReport(state)?.covered_lessons || []
const getUpcomingLessons = (state: ProgressReportStore): string[] => getReport(state)?.upcoming_lessons || []

export const lessons = {
  getCoveredLessons: (state: ProgressReportStore): string[] => getCoveredLessons(state),
  hasCoveredLessons: (state: ProgressReportStore): boolean => isFullArray(getCoveredLessons(state)),
  getUpcomingLessons: (state: ProgressReportStore): string[] => getUpcomingLessons(state),
  hasUpcomingLessons: (state: ProgressReportStore): boolean => isFullArray(getUpcomingLessons(state)),
}
